<script lang="ts" setup>
import { onMounted, onUnmounted, watchEffect } from 'vue'
import { Dialog, DialogContent, DialogClose } from '~/components/ui/dialog'
import JobtokenOnboardingStepZero from '~/components/jobtoken/OnboardingStepZero.vue'
import JobtokenOnboardingStepOne from '~/components/jobtoken/OnboardingStepOne.vue'
import JobtokenOnboardingStepTwo from '~/components/jobtoken/OnboardingStepTwo.vue'
import JobtokenOnboardingStepThree from '~/components/jobtoken/OnboardingStepThree.vue'

const isOpen = ref(false)
const step = ref(1)
const eventBus = useEventBus()
const userStore = useUserStore()
const cookie = useCookie('jobtoken_onboarding_shown')

function openOnboarding() {
	if (process.server) {
		return
	}
	
	const allowedDomains = ['yourservice.ae', 'dev.yourservice.ae', 'localhost']
	const currentDomain = window.location.hostname
	
	if(!userStore.user || userStore.user?.jobtoken_wallet || cookie.value || !allowedDomains.includes(currentDomain)) {
		return
	}
	isOpen.value = true
	step.value = 1
	cookie.value = 'true'
}

watchEffect(() => {
	if (process.client) {
		eventBus.on('maybeOpenJobtokenOnboarding', () => {
			openOnboarding()
		})
	}
})
</script>

<template>
  <Dialog v-model:open="isOpen">
		<DialogContent class="ys-modal-dialog w-full overflow-hidden border-none" :class="{'!bg-black': step !== 1}">
			<DialogClose class="absolute top-4 ltr:right-4 rtl:left-4">
				<Icon name="ri:close-line" size="20px" class="text-gray-500 translate-all hover:text-gray-700" />
			</DialogClose>
			
			<JobtokenOnboardingStepZero v-if="step === 1" @next="step++" />
			<JobtokenOnboardingStepOne v-if="step === 2" @next="step++" />
			<JobtokenOnboardingStepTwo v-if="step === 3" @next="step++" />
			<JobtokenOnboardingStepThree v-if="step === 4" @next="isOpen = false" />
		</DialogContent>
	</Dialog>
</template>